module.exports = __webpack_public_path__ + "img/credit-done.2922a861.svg";